import React from 'react';
import type { IconProps } from '../types';

export const FlagPennant = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      {/* Flag pole */}
      <path
        d="M6 3.5a1 1 0 0 1 1 1V20.5a1 1 0 1 1-2 0V4.5a1 1 0 0 1 1-1Z"
        fill="currentColor"
      />
      {/* Pennant */}
      <path
        d="M8 4.5h9.5c.552 0 .9.59.638 1.09l-.04.07-1.9 3.3 1.9 3.3a.75.75 0 0 1-.6 1.12H8V4.5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default FlagPennant;
